(() => {
  const initCrgApplicationGuideThumb = (root = document) => {
    root.querySelectorAll('[data-crg-application-guide]').forEach((guide) => {
      if (guide.dataset.crgGuideThumbReady === 'true') return;
      guide.dataset.crgGuideThumbReady = 'true';

      const triggers = Array.from(guide.querySelectorAll('[data-crg-guide-trigger]'));
      const inspectorNode = guide.querySelector('.crg-application-guide__inspector');
      const thumbNode = guide.querySelector('[data-crg-guide-thumb]');
      const thumbImageNode = guide.querySelector('[data-crg-guide-thumb-image]');
      if (!triggers.length || !inspectorNode || !thumbNode || !thumbImageNode) return;

      const syncThumb = (preferredTrigger) => {
        const activeTrigger =
          preferredTrigger ||
          guide.querySelector('[data-crg-guide-trigger].is-active') ||
          triggers.find((trigger) => trigger.dataset.part === guide.dataset.activePart) ||
          triggers[0];
        const part = activeTrigger?.dataset.part || '';
        const thumbTrigger =
          activeTrigger?.dataset.thumb
            ? activeTrigger
            : guide.querySelector(`[data-crg-guide-trigger][data-part="${part}"][data-thumb]`);
        const thumb = thumbTrigger?.dataset.thumb || '';

        if (thumb) {
          thumbImageNode.setAttribute('src', thumb);
          thumbImageNode.setAttribute('alt', thumbTrigger.dataset.thumbAlt || activeTrigger?.dataset.title || '');
          thumbNode.hidden = false;
          inspectorNode.classList.add('has-thumb');
          return;
        }

        thumbNode.hidden = true;
        thumbImageNode.removeAttribute('src');
        thumbImageNode.setAttribute('alt', '');
        inspectorNode.classList.remove('has-thumb');
      };

      const syncAfterCurrentEvent = (trigger) => {
        window.setTimeout(() => syncThumb(trigger), 0);
      };

      const navigateToTrigger = (event, trigger) => {
        const href = trigger.getAttribute('href');
        if (!href || href === '#') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return;

        event.preventDefault();
        const targetUrl = new URL(href, window.location.origin);
        window.location.href = `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => syncAfterCurrentEvent(trigger));
        trigger.addEventListener('focus', () => syncAfterCurrentEvent(trigger));
        trigger.addEventListener('click', (event) => {
          syncAfterCurrentEvent(trigger);
          navigateToTrigger(event, trigger);
        });
        trigger.addEventListener('touchstart', () => syncAfterCurrentEvent(trigger), { passive: true });
      });

      const observer = new MutationObserver(() => syncThumb());
      triggers.forEach((trigger) => {
        observer.observe(trigger, { attributes: true, attributeFilter: ['class'] });
      });

      syncThumb();
      window.setTimeout(syncThumb, 250);
      window.setTimeout(syncThumb, 1000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCrgApplicationGuideThumb());
  } else {
    initCrgApplicationGuideThumb();
  }

  document.addEventListener('shopify:section:load', (event) => initCrgApplicationGuideThumb(event.target));
})();
